import Box from "@components/Box";
import AsideNew from "@components/CaseStudyComponents/AsideNew";
import TestimonialSectionCaseStudy from "@components/LandingPageComponents/TestimonialSectionCaseStudy";
import { AppButton } from "@components/Typography";
import "keen-slider/keen-slider.min.css";
import Image from "next/image";
import React, { FC } from "react";
import AchievementCard from "../../components/CaseStudyComponents/AchievementCard";
import RelatedCaseStudies from "../../components/CaseStudyComponents/RelatedCaseStudies";
import NewLayout from "../../components/new-ui/Layout";

const hugg: FC = () => {
    const cardData = [
        {
            imgpath: "https://assets.gallabox.com/gb-home/hugg/hugg1.png",
            title: "Improvement in Click-to-WhatsApp",
            count: "37%",
            by: "ad conversion rates",
            borderColor: "#ACDAF1",
            boxShadowColor: "white",
            fontColor: "#4299E1",
            gradient: "linear-gradient(105.67deg, rgba(215, 235, 245, 0.2) 0%, #D7EBF5 95.66%)",
        },
        {
            imgpath: "https://assets.gallabox.com/gb-home/property2x/property2x-icon2.png",
            title: "Increase in conversion rates for",
            count: "30%",
            by: "first-time customers",
            borderColor: "#9AE6B4",
            boxShadowColor: "white",
            fontColor: "#38A169",
            gradient: "linear-gradient(285.78deg, #ECF8E1 3.17%, rgba(236, 248, 225, 0.2) 96.84%)",
        },
        {
            imgpath: "https://assets.gallabox.com/gb-home/hugg/hugg2.png",
            title: "Growth in number of orders ",
            count: "20%",
            by: "after using Gallabox flows",
            borderColor: "#DEBEF3",
            boxShadowColor: "white",
            fontColor: "#805AD5",
            gradient: "linear-gradient(285.94deg, #EFE1F8 1.79%, rgba(239, 225, 248, 0.2) 98.89%)",
        },
    ];
    const redBoxPoints = [
        "Inability to convert leads from ads",
        "Struggling to hold on to existing customers",
        "Inflexible WhatsApp automation platform",
        "The overflowing Spreadsheet nightmare",
    ];
    const greenBoxPoints = [
        "37% improvement in Click-to-WhatsApp ad conversion rates",
        "30% increase in conversion rates for first-time customers",
        "20% growth in number of orders after using Gallabox flows",
    ];
    const RELATED_CASE_STUDIES = [
        {
            id: 1,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-1.png",
            tag: "Travel & Tourism",
            title: "LivingStone Stays Relocated Their Communications From..",
            link: "/case-study/livingstone-stay",
            description:
                "Founded in 2019, LivingStone Stays is revolutionising the way people spend their leisure time - making holidays a way of life. Their platform is a one-stop ...",
        },
        {
            id: 2,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-3.png",
            tag: "HR & Professional Service",
            title: "Jobstars India Deployed a Multilingual Chatbot to Handle 60%..",
            link: "/case-study/jobstars-india",
            description:
                "Founded in 2002, Jobstars is one of the leading players in the Indian recruitment ecosystem. They believe in combining their passion for people with smart investments ...",
        },
    ];

    return (
        <NewLayout
            title="Automated Support, Improved Productivity, and More Customers: Hugg's Journey with Gallabox"
            description="Here's the awe-inspiring tale of how Hugg boosted efficiency, enhanced customer support, and multiplied conversion rates with Gallabox."
            canonical="https://gallabox.com/case-study/hugg"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/hugg/hugg-og.png" }}
        >
            <header className="grid lg:pt-20 pt-0 pb-4 goireland-header">
                <div className="hero-section h-full flex flex-col-reverse xl:flex-row px-4 xl:justify-between pt-12 lg:pt-0 mx-auto">
                    <div className="w-full h-full lg:w-1/2 lg:space-y-10 space-y-2 lg:pt-14 pt-10 order-1 lg:order-1 lg:overflow-hidden border-transparent">
                        <Image width={483} height={310} alt="enriched-hugg-image" src="https://assets.gallabox.com/gb-home/hugg/hugg-header.png" objectFit="scale-down" />
                    </div>
                    <div className="h-full w-full lg:w-1/2 order-2 lg:order-2 lg:space-y-6 space-y-2 lg:pt-20">
                        <h1 className="font-semibold text-3xl lg:text-4xl lg:leading-tight" style={{ color: "#293056" }}>
                            Maximizing Conversions and Streamlining Support: Hugg&apos;s Transformation with Gallabox
                        </h1>
                        <div className="text-xl " style={{ color: "#4E5BA6" }}>
                            Here&apos;s the awe-inspiring tale of how Hugg boosted efficiency, enhanced customer support, and multiplied conversion rates with Gallabox.
                        </div>
                    </div>
                </div>
            </header>

            <div>
                <section className="max-w-6xl mx-auto flex flex-col items-center sm:flex-row gap-5 my-20 justify-between ">
                    {cardData.map((eachobj) => {
                        return (
                            <AchievementCard
                                key={""}
                                imagePath={eachobj.imgpath}
                                imageTitle={eachobj.title}
                                count={eachobj.count}
                                by={eachobj.by}
                                borderColor={eachobj.borderColor}
                                boxShadowColor={eachobj.boxShadowColor}
                                fontColor={eachobj.fontColor}
                                gradient={eachobj.gradient}
                            />
                        );
                    })}
                </section>
            </div>
            <div className=" mx-auto mt-20 lg:px-0 px-4">
                <div className="max-w-6xl mx-auto flex flex-col sm:flex-row gap-8">
                    <div className=" mx-auto lg:w-64  ">
                        <AsideNew
                            data={[
                                {
                                    title: "Company",
                                    content: "Hugg",
                                },
                                {
                                    title: "Industry",
                                    content: "D2C",
                                },
                                {
                                    title: "Employees",
                                    content: "11-50",
                                },

                                {
                                    title: "Product Used",
                                    content: [
                                        "WhatsApp Shop/Catalog",
                                        "Out-of-the-Box Integrations",
                                        "Lead Qualification Bots",
                                        "Gallabox Chat Flows",
                                        "WhatsApp Broadcasts",
                                        "Click-to-WhatsApp Ads",
                                    ],
                                },
                                {
                                    title: "Chats per Month",
                                    content: "20k+",
                                },
                                {
                                    title: "website",
                                    link: "www.gethugg.com",
                                    content: "gethugg.com",
                                },
                            ]}
                        />
                        <div className=" sm:sticky top-24 pt-4 pb-10">
                            <Box title="Pain Points 🥲" points={redBoxPoints} bgColor="red-50" textColor="red-600" />
                            <Box title="Results 🤩" points={greenBoxPoints} bgColor="green-50" textColor="green-600" />
                        </div>
                    </div>
                    <main className="  lg:px-8 px-4    ">
                        <div>
                            <h3 className="lg:text-5xl text-2xl font-bold pb-10" style={{ color: "#4A5568" }}>
                                The Tale of Hugg Beverages
                            </h3>
                            <p className="lg:text-lg text-base pb-10 text-gray-500 ">
                                Hugg Beverages is a bold D2C venture brought to life by two remarkably innovative siblings, Harsh and Tanvi. Believe it or not, these two
                                haven&apos;t swallowed a pill in over eight years! While it may sound unbelievable, this duo firmly stands by the mantra of &apos;Food is
                                Medicine&apos; and medicine is, well, not always necessary.
                            </p>
                            <p className="lg:text-lg text-base pb-10 text-gray-500 ">
                                Why opt for a chemical cocktail when your daily sustenance can keep you fighting fit? According to research, around 50-60% of those ghastly tablets
                                we consume across our lifetimes (totalling an eye-watering 14,000) are, quite frankly, superfluous. So, armed with this belief, Harsh and Tanvi
                                launched Hugg.
                            </p>
                            <p className="lg:text-lg text-base  text-gray-500 pb-20">
                                Their daring mission? To provide gutsy alternatives to conventional medicine with their range of 100% authentic, ingredient-packed beverages. They
                                are giving pesky digestive issues a run for their money using the secret weapon of traditional Indian ingredients. These drinks don&apos;t just
                                tickle our taste buds, they deliver some seriously measurable results.
                            </p>
                        </div>
                        <div>
                            <h3 className="lg:text-5xl text-2xl  font-bold pb-8" style={{ color: "#4A5568" }}>
                                Challenges Encountered by Hugg
                            </h3>
                            <div className="">
                                <p className="lg:text-lg text-base text-gray-500 pb-6">
                                    Managing a booming beverage business has never been a walk in the park, and Hugg sure had its fair share of roadblocks.
                                </p>
                                <div>
                                    {" "}
                                    <h3 className="text-2xl text-gray-500 font-semibold pb-8">Inability to convert leads from ads</h3>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-10">
                                        Hugg was like a child in a candy store, surrounded by an alluring array of possibilities but unable to turn them into profitable sales.
                                        However, their previous WhatsApp Automation Tool failed them, like a deflated party balloon that promised much but delivered little.
                                    </p>
                                </div>
                                <div>
                                    {" "}
                                    <h3 className="text-2xl text-gray-500 font-semibold pb-8">Struggling to hold on to existing customers</h3>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-10">
                                        Keeping existing customers happy was a herculean task. Customer support was as automated as a manual car wash, and boosting team
                                        productivity was like trying to coax a snail into a sprint. Acquiring new customers was a hill they had yet to climb, with their conversion
                                        rate barely reaching 10%
                                    </p>
                                </div>
                                <div>
                                    {" "}
                                    <h3 className="text-2xl text-gray-500 font-semibold pb-8">Inflexible WhatsApp automation platform</h3>
                                    <p className="lg:text-lg text-base text-gray-500 pb-10">
                                        Hugg’s team was eager to make things happen, but they were hampered by an unimaginative, inflexible, and feature-poor WhatsApp Automation
                                        tool. The sparkle in their team’s eyes faded as they struggled to make the best of a bad situation by trying to integrate their existing
                                        tech stack manually with the platform.
                                    </p>
                                </div>
                                <div>
                                    {" "}
                                    <h3 className="text-2xl text-gray-500 font-semibold pb-8">The overflowing Spreadsheet nightmare</h3>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-20 ">
                                        Hugg was in the midst of customer response chaos and they had absolutely no way to collect customer feedback. To make matters worse, Google
                                        Sheets was uncooperative, like an ex who refuses to communicate. There was no way to know for sure if our lovely customers were even
                                        receiving responses, or if they were disappearing into the void.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div>
                            <h2 className="lg:text-4xl text-2xl  font-bold pb-10" style={{ color: "#4A5568" }}>
                                Hugg&apos;s Partnership with Gallabox for WhatsApp Automation
                            </h2>
                            <div className=" space-y-8">
                                <p className="lg:text-lg text-base  text-gray-500">
                                    Hugg was struggling to find ways to streamline their ad management, eliminate inefficiencies, and reduce costs. Gallabox, a WhatsApp business
                                    automation solution, offered them all the tools they needed to achieve their goals.
                                </p>
                                <p className="lg:text-lg text-base  text-gray-500">
                                    Gallabox allows growing businesses like Hugg to save time and money, while also providing a better customer experience. Hugg used
                                    Gallabox&apos;s platform to increase trust, improve lead conversion, and enhance productivity while offering room for flexibility.
                                </p>
                                <div className="">
                                    <h4 className="text-2xl  text-gray-500 font-semibold pb-8">Play Well with Existing Tech Stack</h4>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        Gallabox helped Hugg significantly reduce their overhead costs and manual redundancy with ready-to-use connectors. With Gallabox, Hugg
                                        created custom workflows that trigger messages based on specific events.
                                    </p>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        This saved Hugg and its team you a lot of time and effort, as they no longer had to manually send messages or update spreadsheets. Gallabox
                                        also helped them integrate seamlessly with popular platforms like Razorpay, making it easy to add payment processing and e-commerce
                                        functionality to their website.
                                    </p>
                                </div>
                                <div className="">
                                    <h4 className="text-2xl  text-gray-500 font-semibold pb-8">Making Support Operations</h4>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        By leveraging the power of Gallabox, Hugg connected their Google Sheets with ingenious formulas, they have been able to masterfully
                                        categorize which customer receives which message and precisely when.
                                    </p>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        But that&apos;s not all! Gallabox’s intelligent chatbots work around the clock enabling the team to deal with almost 800 queries a day with
                                        only a small team. These tireless digital assistants answer repetitive questions, freeing up human employees to focus on more complex tasks.
                                    </p>
                                </div>
                                <TestimonialSectionCaseStudy
                                    testimonialData={{
                                        headerTitle:
                                            "In today's world of instant gratification, the ability to answer customer queries quickly and accurately is not just an advantage, it's a necessity!",
                                        avatarImg: "https://assets.gallabox.com/gb-home/hugg/hugg-ceo.png",
                                        nameText: "Harsh Doshi",
                                        professionText: "Founder & CEO, Hugg Beverages",
                                    }}
                                />
                                <p className="lg:text-lg text-base  text-gray-500">
                                    These chatbots didn&apos;t just answer questions. They also gathered data for lead qualification. That&apos;s like having an assistant who never
                                    sleeps -and never asks for a raise!
                                </p>

                                <ol className="lg:text-lg text-base text-gray-500">
                                    <li>24/7 customer service? Check.</li>
                                    <li>Elevated customer satisfaction? Obviously!</li>
                                    <li>A streamlined operation with reduced overheads? You bet :)</li>
                                </ol>

                                <div className=" space-y-4">
                                    {" "}
                                    <h4 className="text-2xl text-gray-500 font-semibold">Turning Conversations into Conversions with Gallabox</h4>
                                    <p className="lg:text-lg text-base  text-gray-500">
                                        Hugg&apos;s conversion rates for first-time customers increased dramatically to over 30% after implementing Gallabox. They have been working
                                        diligently to improve their funnel, and it has certainly paid off!
                                    </p>
                                    <p className="lg:text-lg text-base  text-gray-500">
                                        Stripping away the clichéd rehearsed responses, Gallabox empowered Hugg with a fusion that was a perfect balance of personalisation and
                                        automation. In addition, they cleverly increased their quiz-to-sample purchases by 20% using Gallabox flows.
                                    </p>
                                    <p className="lg:text-lg text-base  text-gray-500">It appears that Hugg has been &quot;hugging&quot; success quite tightly with Gallabox!</p>
                                </div>

                                <TestimonialSectionCaseStudy
                                    testimonialData={{
                                        headerTitle:
                                            "We switched to Gallabox and never looked back! It's the perfect WhatsApp automation solution for businesses of all sizes. With its powerful automation and tracking features, we've been able to improve our customer support and handle more inquiries than ever before.",
                                        avatarImg: "https://assets.gallabox.com/gb-home/hugg/hugg-ceo.png",
                                        nameText: "Harsh Doshi",
                                        professionText: "Founder & CEO, Hugg Beverages",
                                    }}
                                />
                            </div>
                        </div>
                    </main>
                </div>
            </div>

            <section style={{ backgroundColor: "#FFED82" }} className="flex flex-col items-center justify-center">
                <div className="max-w-6xl mx-auto px-4 md:px-20 py-8">
                    <h4 className="font-bold lg:text-3xl text-base text-center text-yellow-800" style={{ fontSize: "26px" }}>
                        Ready to skyrocket your conversion rates with <br /> Gallabox like Hugg?
                    </h4>
                    <div className="flex justify-center mt-4">
                        {" "}
                        <AppButton buttonText="Get Started" href="https://app.gallabox.com/signup" />
                    </div>
                </div>
            </section>

            <RelatedCaseStudies sectionDescription="Related Case Studies" related={RELATED_CASE_STUDIES} />

            <style jsx>{`
                .goireland-header {
                    background-color: #e3e6f6;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: cover;
                    width: 100vw;
                    height: 500px;
                }
                .goireland-header h1 {
                    font-family: Google Sans;
                    font-style: normal;
                    letter-spacing: 0.02em;
                    color: #162c6f;
                }
                .goireland-header .top-text {
                    font-weight: 500;
                    font-size: 30px;
                    line-height: 38px;
                }
                .goireland-header .bottom-text {
                    font-weight: 700;
                    font-size: 50px;
                    line-height: 64px;
                }
                .case-study-bluebox-slider {
                    font-family: "Google Sans";
                    font-style: normal;
                    letter-spacing: 0.05em;
                    color: #4a5568;
                    background-color: #ffffff;
                    box-shadow: 2.01005px 2.01005px 10.0503px rgba(51, 100, 250, 0.2), inset 0px 0px 10.0503px rgba(122, 152, 244, 0.1);
                    border-radius: 10.0503px;
                }
                .slider-profile-name {
                    font-weight: 700;
                    font-size: 22.1106px;
                    width: fit-content;
                    line-height: 28px;
                }
                .slider-content {
                    font-style: italic;
                    font-weight: 500;
                    font-size: 26.1307px;
                    line-height: 40px;
                    width: fit-content;
                }
                .slider-profile-about {
                    font-weight: 400;
                    font-size: 17.9834px;
                    line-height: 23px;
                    text-align: center;
                }
                .case-study-tag-filter {
                    font-family: "Google Sans";
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14.9744px;
                    line-height: 19px;
                    letter-spacing: 0.02em;
                    color: #2d3748;
                }
                .case-study-filter-checkbox {
                    width: 18px;
                    height: 18px;
                    background-color: #ffffff;
                    border: 1.5px solid #0083ff;
                    border-radius: 2px;
                }
                .case-study-carousal {
                    border-radius: 10px;
                }
                .case-study-carousal-content {
                    font-family: "Google Sans";
                    font-style: normal;
                    font-weight: 500;
                    font-size: 24px;
                    line-height: 40px;
                    letter-spacing: 0.02em;
                    color: #ffffff;
                }
                .case-study-carousal .redirect {
                    font-family: "Google Sans";
                    font-style: normal;
                    font-weight: 400;
                    font-size: 15px;
                    line-height: 19px;
                    letter-spacing: 0.02em;
                    color: #bababa;
                }
                .case-study-carousal .redirect::after {
                    content: url("https://assets.gallabox.com/gb-home/case-study/redirect-arrow.png");
                    position: relative;
                    left: 4px;
                    top: 2px;
                }
                .carousal-img {
                    width: 530px;
                    background-color: #d9d9d9;
                    border-radius: 4.99649px;
                }
                .filter-title-case-study {
                    font-family: "Google Sans";
                    font-style: normal;
                    font-weight: 500;
                    font-size: 15px;
                    line-height: 19px;
                    text-align: center;
                    letter-spacing: 0.02em;
                    color: #838383;
                }
                .slider-btn-right {
                    position: absolute;
                    top: 150px;
                    right: -35px;
                    z-index: 5;
                }
                .slider-btn-left {
                    position: absolute;
                    top: 150px;
                    left: -35px;
                    z-index: 5;
                }
                .slide-count-case-study {
                    width: 60px;
                    height: 60px;
                    color: #3364fa;
                    background-color: #ffffff;
                    border: 1px solid rgba(51, 100, 250, 0.1);
                    border-radius: 50%;
                    box-shadow: 2px 2px 10px rgba(51, 100, 250, 0.2), inset 0px 0px 10px rgba(122, 152, 244, 0.1);
                }
                .left-arrow {
                    width: 30px;
                    height: 30px;
                    background-color: #ffffff;
                    border: 1px solid rgba(51, 100, 250, 0.1);
                    border-radius: 50%;
                    box-shadow: 2px 2px 10px rgba(51, 100, 250, 0.2), inset 0px 0px 10px rgba(122, 152, 244, 0.1);
                }
                .right-arrow {
                    width: 30px;
                    height: 30px;
                    background-color: #ffffff;
                    border: 1px solid rgba(51, 100, 250, 0.1);
                    border-radius: 50%;
                    box-shadow: 2px 2px 10px rgba(51, 100, 250, 0.2), inset 0px 0px 10px rgba(122, 152, 244, 0.1);
                }

                @media (max-width: 35rem) {
                    .goireland-header {
                        background-size: contain;
                        height: 100%;
                    }
                    .goireland-header .top-text {
                        font-size: 20px;
                    }
                    .goireland-header .bottom-text {
                        font-size: 30px;
                        padding-inline: 1rem;
                        line-height: 35px;
                        margin-top: 0.7rem;
                    }
                    .case-study-carousal {
                        border-radius: 10px;
                    }
                    .carousal-img {
                        width: 100%;
                    }
                    .case-study-carousal-content {
                        font-size: 18px;
                        line-height: 28px;
                        padding-inline: 1rem;
                        margin-top: 0.5rem;
                        margin-bottom: 1rem;
                    }
                    .slide-count-case-study {
                        width: 50px;
                        height: 50px;
                    }
                    .left-arrow {
                        width: 30px;
                        height: 30px;
                    }
                    .right-arrow {
                        width: 30px;
                        height: 30px;
                    }
                    .slider-profile-name {
                        font-size: 19px;
                        line-height: 30px;
                    }
                    .slider-profile-about {
                        font-size: 18px;
                        line-height: 23px;
                    }
                    .slider-content {
                        font-size: 16px;
                        line-height: 23px;
                    }
                    .slider-btn-right {
                        top: 180px;
                        right: -5px;
                        width: 3rem;
                    }
                    .slider-btn-left {
                        top: 180px;
                        left: -5px;
                        width: 3rem;
                    }
                }
            `}</style>
        </NewLayout>
    );
};

export default hugg;
